export default "__VITE_ASSET__BeAK$Vuk__"